import { ThemeProvider } from 'next-themes';
import { type ReactNode } from 'react';

export default function ThemeModesProvider({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider defaultTheme="light" themes={['light', 'dark', 'lowcontrast']}>
      {children}
    </ThemeProvider>
  );
}
